<div #dExpand  class="d-expand" [style.max-height.px]="height" style=" overflow: hidden;">
  <div #dExpandInner class="d-expand-inner">
    <ng-content></ng-content>
  </div>
</div>

@if (dExpandInner.offsetHeight > height) { <!-- !p.pExpanded && -->
  
<div>
  
  <div class="expand-gradient expand-100-off" [class.not-expanded]="!expanded">
    <div class="expand-button-div text-right" >

      <button nz-button nzType="default" nzSize="small" (click)="$event.preventDefault(); expanded = !expanded; dExpand.style.maxHeight = (expanded ? 'none' : height + 'px');" class="text-underline">
        {{ (expanded ? 'app.lib.common.showLess' : 'app.lib.common.showMore') | actrans }}
      </button>
    </div>
  </div>

</div>
}
